export type ChequePrintTemplateKind = "slip" | "nakladnaya" | "other";

export type ChequePrintTemplate = {
  printtemplateid: number;
  name: string;
  value: string | null;
  slipdefault: 0 | 1;
  nakladnayadefault: 0 | 1;
  otherdefault: 0 | 1;
  deleted?: 0 | 1;
  created_at?: string;
  updated_at?: string;
};

export type CreateChequePrintTemplateBody = {
  name: string;
  value?: string | null;
  slipdefault?: 0 | 1;
  nakladnayadefault?: 0 | 1;
  otherdefault?: 0 | 1;
  printtemplateid?: number;
};

export type UpdateChequePrintTemplateBody = {
  printtemplateid: number;
  name?: string;
  value?: string | null;
  slipdefault?: 0 | 1;
  nakladnayadefault?: 0 | 1;
  otherdefault?: 0 | 1;
  deleted?: boolean | 0 | 1;
};

export function templateKindFromFlags(
  t: Pick<
    ChequePrintTemplate,
    "slipdefault" | "nakladnayadefault" | "otherdefault"
  >
): ChequePrintTemplateKind {
  if (t.slipdefault === 1) return "slip";
  if (t.nakladnayadefault === 1) return "nakladnaya";
  if (t.otherdefault === 1) return "other";
  return "other";
}

export function flagsFromKind(kind: ChequePrintTemplateKind): {
  slipdefault: 0 | 1;
  nakladnayadefault: 0 | 1;
  otherdefault: 0 | 1;
} {
  return {
    slipdefault: kind === "slip" ? 1 : 0,
    nakladnayadefault: kind === "nakladnaya" ? 1 : 0,
    otherdefault: kind === "other" ? 1 : 0,
  };
}
